import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop
 * Restores scroll to the top whenever the route changes.
 * It prefers scrolling the main app container with id 'app-main-scroll'
 * (since this app uses an inner scroll area), and falls back to window.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const scroller = document.getElementById('app-main-scroll');
    if (scroller && typeof scroller.scrollTo === 'function') {
      scroller.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [pathname, search, hash]);

  return null;
}
